import { AnnouncementModalLayout, Box, Button, CustomModalLayout, Heading, Loader, Text, TextButton } from '@wix/design-system';
import { ChevronLeft } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { GetStarted, Time } from '@wix/wix-ui-icons-common/lazy';
import { EntriIntroModalDataBi, EntriIntroModalDataHooks } from './EntriIntroModalModule';
import { DomainSearchSuiteModule } from '../../../../../../domainSearchSuite.module';
import { CheckListView } from '../../../../../../../components';
export const EntriIntroModal = _ref => {
  let {
    domain,
    siteName,
    onContinue,
    onManualFlow,
    onRequestClose,
    fullPage
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const [isCtaLoading, setIsCtaLoading] = React.useState(false);
  const domainName = domain.formattedInput ?? domain;
  const title = siteName != null && siteName.trim() ? t('entri.intro_modal.title', {
    domainName,
    siteName
  }) : t('entri.intro_modal.title.no_site_name', {
    domainName
  });
  React.useEffect(() => {
    EntriIntroModalDataBi.onEntriIntroModal == null || EntriIntroModalDataBi.onEntriIntroModal({
      action: 'view',
      domainName
    });
  }, []);
  const onContinueHandler = async () => {
    EntriIntroModalDataBi.onEntriIntroModal == null || EntriIntroModalDataBi.onEntriIntroModal({
      action: 'continue',
      domainName
    });
    try {
      setIsCtaLoading(true);
      await onContinue();
    } finally {
      setIsCtaLoading(false);
    }
  };
  const onManualFlowHandler = () => {
    EntriIntroModalDataBi.onEntriIntroModal == null || EntriIntroModalDataBi.onEntriIntroModal({
      action: 'manual',
      domainName
    });
    onManualFlow();
  };
  if (fullPage) {
    return /*#__PURE__*/React.createElement(CustomModalLayout, {
      dataHook: EntriIntroModalDataHooks.component,
      width: "100%",
      height: "100%",
      maxWidth: "100%",
      removeContentPadding: true,
      style: {
        borderRadius: 0
      },
      footnote: /*#__PURE__*/React.createElement(Box, {
        width: "100%",
        align: "center"
      }, /*#__PURE__*/React.createElement(EntriIntroModalFooter, {
        onManualFlow: onManualFlowHandler,
        domainName: domainName,
        centered: true
      })),
      content: /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        height: "100%",
        overflowY: "auto"
      }, /*#__PURE__*/React.createElement(Box, {
        margin: "24px 32px",
        flex: "0 0 auto"
      }, /*#__PURE__*/React.createElement(TextButton, {
        skin: "dark",
        prefixIcon: /*#__PURE__*/React.createElement(ChevronLeft, null),
        onClick: onRequestClose
      }, t('entri.intro_modal.back_cta'))), /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        align: "center",
        verticalAlign: "middle",
        width: "100%",
        padding: "0 32px 32px",
        flex: "1 1 auto",
        boxSizing: "border-box"
      }, /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        align: "center",
        textAlign: "center",
        width: "100%",
        maxWidth: "384px"
      }, /*#__PURE__*/React.createElement(Heading, {
        size: "large"
      }, title), /*#__PURE__*/React.createElement(Box, {
        marginTop: "24px"
      }, /*#__PURE__*/React.createElement(EntriIntroModalBody, {
        domainName: domainName,
        gap: "24px",
        iconGap: "18px"
      })), /*#__PURE__*/React.createElement(Box, {
        marginTop: "24px",
        width: "100%"
      }, /*#__PURE__*/React.createElement(Button, {
        size: "large",
        fullWidth: true,
        disabled: isCtaLoading,
        onClick: onContinueHandler
      }, isCtaLoading ? /*#__PURE__*/React.createElement(Loader, {
        size: "tiny",
        color: "white"
      }) : t('entri.intro_modal.primary_cta'))))))
    });
  }
  return /*#__PURE__*/React.createElement(AnnouncementModalLayout, {
    dataHook: EntriIntroModalDataHooks.component,
    title: title,
    primaryButtonText: t('entri.intro_modal.primary_cta'),
    onCloseButtonClick: onRequestClose,
    primaryButtonOnClick: onContinueHandler,
    footnote: /*#__PURE__*/React.createElement(EntriIntroModalFooter, {
      onManualFlow: onManualFlowHandler,
      domainName: domainName
    })
  }, /*#__PURE__*/React.createElement(Box, {
    marginTop: "28px"
  }, /*#__PURE__*/React.createElement(EntriIntroModalBody, {
    domainName: domainName
  })));
};
export const EntriIntroModalBody = _ref2 => {
  let {
    domainName,
    gap,
    iconGap = '12px'
  } = _ref2;
  const {
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(CheckListView, {
    defaultTextProps: {
      size: 'medium'
    },
    defaultCheckValue: true,
    gap: gap,
    iconGap: iconGap,
    items: [{
      checkIcon: /*#__PURE__*/React.createElement(GetStarted, null),
      content: /*#__PURE__*/React.createElement(Trans, {
        i18nKey: "entri.intro_modal.content.bullet_1"
      })
    }, {
      checkIcon: /*#__PURE__*/React.createElement(Time, null),
      content: /*#__PURE__*/React.createElement(Trans, {
        i18nKey: "entri.intro_modal.content.bullet_2",
        values: {
          domainName
        }
      })
    }]
  });
};
export const EntriIntroModalFooter = _ref3 => {
  let {
    onManualFlow,
    domainName,
    centered
  } = _ref3;
  const {
    locale,
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Text, {
    size: "small",
    textAlign: centered ? 'center' : undefined
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "entri.intro_modal.footer.content",
    components: {
      1: /*#__PURE__*/React.createElement(TextButton, {
        dataHook: EntriIntroModalDataHooks.manualBtn,
        size: "small",
        disabled: !onManualFlow,
        as: "a",
        onClick: () => {
          onManualFlow == null || onManualFlow();
        }
      }),
      2: /*#__PURE__*/React.createElement(TextButton, {
        dataHook: EntriIntroModalDataHooks.supportLink,
        size: "small",
        skin: "dark",
        underline: "always",
        style: centered ? {
          display: 'block',
          margin: '0 auto'
        } : undefined,
        onClick: () => {
          const link = `https://support.wix.com/${locale}/article/connecting-a-domain-purchased-elsewhere`;
          EntriIntroModalDataBi.onEntriIntroModal == null || EntriIntroModalDataBi.onEntriIntroModal({
            action: 'support_link',
            domainName,
            link
          });
          window.open(link, '_blank');
        }
      })
    }
  }));
};
//# sourceMappingURL=EntriIntroModal.js.map